import React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { useThemeMode } from '../context/ThemeContext';

// Sits on the charcoal navbar in both modes, so the icon stays light.
function ThemeToggle() {
    const { resolvedMode, toggleMode } = useThemeMode();
    const isDark = resolvedMode === 'dark';
    const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';

    return (
        <Tooltip title={label}>
            <IconButton
                onClick={toggleMode}
                aria-label={label}
                sx={{ color: '#e2e8f0' }}
            >
                {isDark ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
            </IconButton>
        </Tooltip>
    );
}

export default ThemeToggle;
